import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../../../Components/comman/Header";
import SideMenu from "../SideMenu";
import { Form, Tab, InputGroup, FormControl, Button } from "react-bootstrap";
import Select from "react-select";
import { components } from "react-select";
import customStyles from "../../../Components/SelectCustomStyles";
import tableData from "../../../Components//TableData";
import { Tooltip } from "react-tooltip";
import {
  BsFillInfoCircleFill,
  BsCloudUploadFill,
  BsUpload,
} from "react-icons/bs";
import "react-country-state-city/dist/react-country-state-city.css";
import { Notification, toaster, Uploader } from "rsuite";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import Images from "../../../Helpers/Images";
import MobileHeader from "../../../Components/comman/MobileHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Auth } from "../../../Contexts/AuthContext";

const CreateCampagin = () => {
  const location = useLocation();
  let { id } = useParams();
  const navigate = useNavigate();
  const { auth } = useContext(Auth);
  const { MultiValue, Option } = components;
  const [herofile, setHerofile] = useState("");
  const [fileInfo, setFileInfo] = useState(null);
  const [heroPreview, setHeroPreview] = useState(null);
  const [campaignData, setCampaignData] = useState({});
  const [galleryImages, setGalleryImages] = useState([]);
  const [inspritionImages, setInspritionImages] = useState([]);
  const [campaignFormData, setCampaignFormData] = useState({
    campaign_title: location?.state?.title,
    retail_value: { type: "fixed" },
    paid_campaign_payment: { type: "fixed" },
  });
  const [contentFormatCounts, setContentFormatCounts] = useState({
    igtv: "",
    post: "",
    reel: "",
    story: "",
    video: "",
    shorts: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [validationErrors, setValidationErrors] = useState([]);
  const [activeMenu, setActiveMenu] = useState("general");
  const general = useRef(null);
  const compensation = useRef(null);
  const requirnment = useRef(null);
  const deliverables = useRef(null);
  useEffect(() => {
    getcategories();
  }, []);
  const scrollToSection = (sectionRef) => {
    sectionRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
      inline: "nearest",
    });

    setActiveMenu(sectionRef);
  };
  const IconSingleValue = (props) => (
    <MultiValue {...props}>
      <img
        src={props.data.icon}
        style={{
          height: "20px",
          width: "20px",
          borderRadius: "50%",
          marginRight: "10px",
        }}
      />
      {props.data.label}
    </MultiValue>
  );
  const IconSingleValueCountry = (props) => (
    <MultiValue {...props}>{props.data.name}</MultiValue>
  );
  const IconOption = (props) => (
    <Option {...props}>
      <img
        src={props.data.icon}
        style={{ height: "20px", width: "20px", marginRight: "10px" }}
      />
      {props.data.label}
    </Option>
  );
  const CountryOption = (props) => (
    <Option {...props}>{props.data.name}</Option>
  );
  const handleOnChange = (name, value) => {
    setCampaignFormData({ ...campaignFormData, [name]: value });
    // console.log(campaignFormData);
  };
  const getcategories = () => {
    let config = {
      url: ApiUrl.getCampaignCreationData,
      method: "GET",
    };
    APIRequest(
      config,
      (res) => {
        setCampaignData(res?.data);
        setIsLoading(false);
        console.log("campaignData", campaignData);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
      }
    );
  };
  const hideValidationOnChange = (name) => {
    const IsError = validationErrors?.find((v) => v.field === name);
    if (IsError !== undefined) {
      setValidationErrors(validationErrors?.filter((v) => v.field !== name));
    }
  };
  const previewFile = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };
  const handleHeroUpload = (data) => {
    const updatedFormData = {
      ...campaignFormData,
      campaignLogo: data,
    };
    hideValidationOnChange("campaignLogo");
    setCampaignFormData(updatedFormData);
    setHerofile(data);
  };
  const handleSubmit = async () => {
    let config = {
      url: ApiUrl.newCampaign,
      method: "POST",
      body: {
        ...campaignFormData,
        campaignLogo: campaignFormData?.campaignLogo?.file,
        content_format: contentFormatCounts,
        gallery: galleryImages?.map((item) => item.file),
        inspiration_board: inspritionImages?.map((item) => item.file),
        social_channels: campaignFormData?.campaign_platform?.map(
          (item) => item.id
        ),
        id: id,
      },
    };
    setIsLoading(true);
    APIRequest(
      config,
      (res) => {
        toaster.push(
          <Notification type="success" header="success" closable>
            {"🌟 Campaign Created Successfully!! 🌟"}
          </Notification>,
          {
            placement: "topCenter",
          }
        );
        navigate("/brand/campaigns", { replace: true });
      },
      (err) => {
        console.log(err);
        if (err?.response?.status === 422) {
          console.log("error++", err?.response?.data?.message);
          toaster.push(
            <Notification type="error" header="error" closable>
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        } else if (err.response.status === 401) {
          toaster.push(
            <Notification type="error" header="error" closable>
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topCenter",
            }
          );
        }
        setIsLoading(false);
      }
    );
  };
  const getSocialPlatform = (item) => {
    const findItem = campaignData?.social_platForms_list?.find(
      (s) => s.value == item
    );
    if (findItem != undefined) return findItem;
    return {};
  };
  const getSocialPlatformbyName = (platform) => {
    const findItem = campaignFormData?.campaign_platform?.find(
      (item) => item.name.toUpperCase() == platform.toUpperCase()
    );
    if (findItem != undefined) return true;
    return false;
  };
  const getFollowersRange = () => {
    if (
      !campaignFormData?.campaign_platform ||
      campaignFormData.campaign_platform.length === 0
    )
      return null;

    const followers = campaignFormData.campaign_platform
      .map((platform) => {
        const followerValue = platform?.social_engagement_data?.follower;
        return followerValue ? parseFloat(followerValue) : null;
      })
      .filter((follower) => follower !== null && follower > 0);

    if (followers.length === 0) return null;

    const min = Math.min(...followers);
    const max = Math.max(...followers);

    return min === max ? `${min}` : `${min}-${max}`;
  };
  const getEngagementRange = () => {
    if (
      !campaignFormData?.campaign_platform ||
      campaignFormData.campaign_platform.length === 0
    )
      return null;
    const engagements = campaignFormData.campaign_platform
      .map((platform) => {
        const engagementValue = platform?.social_engagement_data?.engagement;
        return engagementValue ? parseFloat(engagementValue) : null;
      })
      .filter((engagement) => engagement !== null && engagement > 0);
    if (engagements.length === 0) return null;
    const min = Math.min(...engagements);
    const max = Math.max(...engagements);
    return min === max ? `${min}%` : `${min}%-${max}%`;
  };
  const getAgeRange = () => {
    const minAge = campaignFormData?.age?.min;
    const maxAge = campaignFormData?.age?.max;

    if (minAge && maxAge) {
      return minAge === maxAge ? `${minAge}` : `${minAge}-${maxAge}`;
    }

    if (minAge) {
      return `${minAge}+`;
    }
    if (maxAge) {
      return `Up to ${maxAge}`;
    }
    if (
      campaignFormData?.age_restriction?.includes("Alcohol") ||
      campaignFormData?.age_restriction?.includes("Cannabis")
    ) {
      return "21+";
    }

    return "-";
  };
  const getCountryCodes = () => {
    const selected = campaignData?.loactions?.filter((c) =>
      campaignFormData?.location_id?.includes(c.id)
    );
    return (
      selected?.map((c) => c.name?.substring(0, 3).toUpperCase()).join(", ") ||
      "-"
    );
  };
  const getSelectedNiches = () => {
    const selected = campaignData?.categories_list?.filter((n) =>
      campaignFormData?.category_id?.includes(n.value)
    );
    return selected?.map((n) => n.name || n.label).join(", ") || "-";
  };
  return (
    <div className="brand-dashboard-wrapper">
      <Header />
      <MobileHeader />
      <div className="brand-dashboard-inner ">
        <Tab.Container activeKey={`campaigns`}>
          <SideMenu />
          <div className="brand-dashboard-content-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"campaigns"}>
                <div className="create-campagin-wrapper">
                  <div className="campagin-builder-wrapper">
                    <div className="builder-inner">
                      <h6 className="heading-title">Campaign Builder</h6>
                      <div ref={general} className="general-box box">
                        <h4 className="section-heading">General</h4>
                        <Form>
                          {/* campaign title */}
                          <Form.Group controlId="formInput" className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                              type="text"
                              value={campaignFormData?.campaign_title || ""}
                              onChange={(e) =>
                                handleOnChange("campaign_title", e.target.value)
                              }
                            />
                          </Form.Group>
                          {/* Campaign Strategy */}
                          <Form.Group controlId="formSelect1" className="mb-3">
                            <Form.Label>Campaign Strategy</Form.Label>
                            <Select
                              options={campaignData?.CampaignStrategy?.map(
                                (item) => ({ label: item.name, value: item.id })
                              )}
                              placeholder={"Select"}
                              styles={customStyles}
                              onChange={(value) => {
                                handleOnChange(
                                  "campaign_strategy",
                                  value.value
                                );
                              }}
                            />
                          </Form.Group>
                          {/* starategy detail table */}
                          <div className="table-container">
                            <table>
                              <thead>
                                <tr>
                                  <th>Type</th>
                                  <th>Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tableData.map((row, index) => (
                                  <tr key={index}>
                                    <td className="type">{row.type}</td>
                                    <td>{row.description}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          {/* social channels */}
                          {campaignFormData?.campaign_strategy !== 1 && (
                            <Form.Group
                              controlId="formSelect2"
                              className="mb-2"
                            >
                              <Form.Label>Social Channel(s)</Form.Label>
                              <Select
                                options={campaignData?.social_platForms_list}
                                placeholder={"Select"}
                                styles={customStyles}
                                isMulti
                                components={{
                                  MultiValue: IconSingleValue,
                                  Option: IconOption,
                                }}
                                onChange={(selectedOptions) => {
                                  handleOnChange(
                                    "social_channels",
                                    selectedOptions?.map(
                                      (option) => option.value
                                    )
                                  );
                                  const EngagementData = selectedOptions?.map(
                                    (item) => ({
                                      name: item.label,
                                      id: item.value,
                                      social_engagement_data: {
                                        follower: "",
                                        engagement: "",
                                      },
                                    })
                                  );
                                  handleOnChange(
                                    "campaign_platform",
                                    EngagementData
                                  );
                                }}
                              />
                            </Form.Group>
                          )}
                        </Form>
                      </div>
                      <div ref={compensation} className="compensation-box box">
                        <h4 className="section-heading">Compensation</h4>
                        <p>
                          Enter details about your campaign and the product to
                          be promoted.
                        </p>
                        <div className="inner-content">
                          {/* retail box */}
                          <div className="retail-box">
                            <div className="head">
                              <a
                                data-tooltip-id="tooltip"
                                data-tooltip-content="To ensure you have plenty of creators to choose from, we recommend at least $20 in product or service value for every 1k in the required followers you set."
                              >
                                <BsFillInfoCircleFill />
                              </a>
                              <Tooltip id="tooltip" place="top" />
                              <h6>
                                Retail Value
                                <span> (of your product or service)</span>
                              </h6>
                            </div>
                            <Form>
                              <Form.Check
                                type="radio"
                                id="fixed"
                                name="priceType"
                                label="Fixed"
                                checked={
                                  campaignFormData?.retail_value?.type ===
                                  "fixed"
                                }
                                onChange={() => {
                                  handleOnChange("retail_value", {
                                    ...campaignFormData?.retail_value,
                                    type: "fixed",
                                    value: "",
                                  });
                                }}
                              />
                              <Form.Check
                                type="radio"
                                id="range"
                                name="priceType"
                                label="Range"
                                checked={
                                  campaignFormData?.retail_value?.type ===
                                  "range"
                                }
                                onChange={() => {
                                  handleOnChange("retail_value", {
                                    ...campaignFormData?.retail_value,
                                    type: "range",
                                    value: {},
                                  });
                                }}
                              />
                              {campaignFormData?.retail_value?.type ===
                              "fixed" ? (
                                <Form.Group
                                  controlId="formFixedValue"
                                  className="mt-2"
                                >
                                  <InputGroup>
                                    <InputGroup.Text>$</InputGroup.Text>
                                    <FormControl
                                      type="number"
                                      value={
                                        campaignFormData?.retail_value?.value ||
                                        ""
                                      }
                                      onChange={(e) => {
                                        handleOnChange("retail_value", {
                                          ...campaignFormData?.retail_value,
                                          value: e.target.value,
                                        });
                                      }}
                                    />
                                  </InputGroup>
                                </Form.Group>
                              ) : (
                                <div className="mt-2 range-input">
                                  <Form.Group controlId="formRangeMinValue">
                                    <InputGroup>
                                      <InputGroup.Text>Min $</InputGroup.Text>
                                      <FormControl
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={
                                          campaignFormData?.retail_value?.value
                                            ?.min || ""
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value === "") {
                                            handleOnChange("retail_value", {
                                              ...campaignFormData?.retail_value,
                                              value: {
                                                ...campaignFormData
                                                  ?.retail_value?.value,
                                                min: "",
                                              },
                                            });
                                            return;
                                          }
                                          if (value.includes(".")) {
                                            const intValue =
                                              value.split(".")[0];
                                            const numValue =
                                              parseInt(intValue) || 0;
                                            const finalValue =
                                              numValue < 0 ? "0" : intValue;

                                            handleOnChange("retail_value", {
                                              ...campaignFormData?.retail_value,
                                              value: {
                                                ...campaignFormData
                                                  ?.retail_value?.value,
                                                min: finalValue,
                                              },
                                            });
                                            return;
                                          }
                                          const numValue = parseInt(value);
                                          const finalValue =
                                            numValue < 0 ? "0" : value;
                                          handleOnChange("retail_value", {
                                            ...campaignFormData?.retail_value,
                                            value: {
                                              ...campaignFormData?.retail_value
                                                ?.value,
                                              min: finalValue,
                                            },
                                          });
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.key === "." || e.key === ",") {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    </InputGroup>
                                    {campaignFormData?.retail_value?.value?.min?.includes(
                                      "."
                                    ) && (
                                      <Form.Text className="text-danger small">
                                        Decimal values are not allowed. Using{" "}
                                        {
                                          campaignFormData?.retail_value?.value?.min?.split(
                                            "."
                                          )[0]
                                        }
                                      </Form.Text>
                                    )}
                                    {parseInt(
                                      campaignFormData?.retail_value?.value?.min
                                    ) < 0 && (
                                      <Form.Text className="text-danger small">
                                        Minimum value cannot be negative
                                      </Form.Text>
                                    )}
                                  </Form.Group>

                                  <Form.Group
                                    controlId="formRangeMaxValue"
                                    className=""
                                  >
                                    <InputGroup>
                                      <InputGroup.Text>Max $</InputGroup.Text>
                                      <FormControl
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={
                                          campaignFormData?.retail_value?.value
                                            ?.max || ""
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value === "") {
                                            handleOnChange("retail_value", {
                                              ...campaignFormData?.retail_value,
                                              value: {
                                                ...campaignFormData
                                                  ?.retail_value?.value,
                                                max: "",
                                              },
                                            });
                                            return;
                                          }
                                          if (value.includes(".")) {
                                            const intValue =
                                              value.split(".")[0];
                                            const numValue =
                                              parseInt(intValue) || 0;
                                            const finalValue =
                                              numValue < 0 ? "0" : intValue;

                                            handleOnChange("retail_value", {
                                              ...campaignFormData?.retail_value,
                                              value: {
                                                ...campaignFormData
                                                  ?.retail_value?.value,
                                                max: finalValue,
                                              },
                                            });
                                            return;
                                          }
                                          const numValue = parseInt(value);
                                          const finalValue =
                                            numValue < 0 ? "0" : value;

                                          handleOnChange("retail_value", {
                                            ...campaignFormData?.retail_value,
                                            value: {
                                              ...campaignFormData?.retail_value
                                                ?.value,
                                              max: finalValue,
                                            },
                                          });
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.key === "." || e.key === ",") {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    </InputGroup>
                                    {campaignFormData?.retail_value?.value?.max?.includes(
                                      "."
                                    ) && (
                                      <Form.Text className="text-danger small d-block">
                                        Decimal values are not allowed. Using{" "}
                                        {
                                          campaignFormData?.retail_value?.value?.max?.split(
                                            "."
                                          )[0]
                                        }
                                      </Form.Text>
                                    )}

                                    {parseInt(
                                      campaignFormData?.retail_value?.value?.max
                                    ) < 0 && (
                                      <Form.Text className="text-danger small d-block">
                                        Maximum value cannot be negative
                                      </Form.Text>
                                    )}

                                    {campaignFormData?.retail_value?.value
                                      ?.min !== "" &&
                                      campaignFormData?.retail_value?.value
                                        ?.max !== "" &&
                                      parseInt(
                                        campaignFormData?.retail_value?.value
                                          ?.max
                                      ) <=
                                        parseInt(
                                          campaignFormData?.retail_value?.value
                                            ?.min
                                        ) && (
                                        <Form.Text className="text-danger small d-block">
                                          Maximum value must be greater than
                                          minimum value
                                          {
                                            campaignFormData?.retail_value
                                              ?.value?.min
                                          }
                                        </Form.Text>
                                      )}
                                  </Form.Group>
                                </div>
                              )}
                            </Form>
                          </div>
                          {/* credit card box */}
                          <div className="CCcard-box">
                            <div className="head">
                              <a
                                data-tooltip-id="tooltip"
                                data-tooltip-content="Request to place a hold on the creator's credit card for the value of the product you are shipping to them. This may limit the amount of opt-ins you receive for this campaign. This is not a guarantee, but will ensure creators are held accountable and more likely to post on time."
                              >
                                <BsFillInfoCircleFill />
                              </a>
                              <Tooltip id="tooltip" place="top" />
                              <h6>Credit Card Hold</h6>
                            </div>
                            <div key={"checkbox"} className="mb-3 mt-2">
                              <Form.Check
                                type={"Checkbox"}
                                label={"Required"}
                                className=""
                                onClick={() =>
                                  handleOnChange(
                                    "creditCardHold",
                                    !campaignFormData?.creditCardHold || false
                                  )
                                }
                              />
                            </div>
                          </div>
                          {/* paid box  */}
                          <div className="paid-box">
                            <div className="head">
                              <a
                                data-tooltip-id="tooltip"
                                data-tooltip-content="If you are paying the creator in addition to product, please indicate that here. We recommend $150 in payment for every 10k followers."
                              >
                                <BsFillInfoCircleFill />
                              </a>
                              <Tooltip id="tooltip" place="top" />
                              <h6>Paid Campaign</h6>
                            </div>
                            <div key={"checkbox"} className="mb-3 mt-2">
                              <Form.Check
                                type={"Checkbox"}
                                label={"Creator will also be provided payment"}
                                className=""
                                checked={
                                  campaignFormData?.paid_campaign_payment ||
                                  false
                                }
                                onClick={() =>
                                  handleOnChange(
                                    "paid_campaign_payment",
                                    !campaignFormData?.paid_campaign_payment ||
                                      false
                                  )
                                }
                              />
                            </div>
                            {/* payment */}
                            {campaignFormData?.paid_campaign_payment && (
                              <div className="paymentBox">
                                <h6>Payment</h6>
                                <Form>
                                  <Form.Check
                                    type="radio"
                                    id="fixedPayment"
                                    name="priceType"
                                    label="Fixed"
                                    checked={
                                      campaignFormData?.paid_campaign_payment
                                        ?.type === "fixed"
                                    }
                                    onChange={() => {
                                      handleOnChange("paid_campaign_payment", {
                                        ...campaignFormData?.paid_campaign_payment,
                                        type: "fixed",
                                        value: "",
                                      });
                                    }}
                                  />
                                  <Form.Check
                                    type="radio"
                                    id="range"
                                    name="priceType"
                                    label="Range"
                                    checked={
                                      campaignFormData?.paid_campaign_payment
                                        ?.type === "range"
                                    }
                                    onChange={() => {
                                      handleOnChange("paid_campaign_payment", {
                                        ...campaignFormData?.paid_campaign_payment,
                                        type: "range",
                                        value: {},
                                      });
                                    }}
                                  />
                                  {campaignFormData?.paid_campaign_payment
                                    ?.type === "fixed" ? (
                                    <Form.Group
                                      controlId="formFixed67Value"
                                      className="mt-2"
                                    >
                                      <InputGroup>
                                        <InputGroup.Text>$</InputGroup.Text>
                                        <FormControl
                                          type="number"
                                          value={
                                            campaignFormData
                                              ?.paid_campaign_payment?.value ||
                                            ""
                                          }
                                          onChange={(e) => {
                                            handleOnChange(
                                              "paid_campaign_payment",
                                              {
                                                ...campaignFormData?.paid_campaign_payment,
                                                value: e.target.value,
                                              }
                                            );
                                          }}
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  ) : (
                                    <div className="mt-2 range-input">
                                      <Form.Group controlId="formRangeMinValue">
                                        <InputGroup>
                                          <InputGroup.Text>
                                            Min $
                                          </InputGroup.Text>
                                          <FormControl
                                            type="number"
                                            min="0"
                                            step="1"
                                            value={
                                              campaignFormData
                                                ?.paid_campaign_payment?.value
                                                ?.min || ""
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;

                                              // Handle empty value
                                              if (value === "") {
                                                handleOnChange(
                                                  "paid_campaign_payment",
                                                  {
                                                    ...campaignFormData?.paid_campaign_payment,
                                                    value: {
                                                      ...campaignFormData
                                                        ?.paid_campaign_payment
                                                        ?.value,
                                                      min: "",
                                                    },
                                                  }
                                                );
                                                return;
                                              }
                                              const intValue = Math.floor(
                                                parseFloat(value)
                                              );
                                              const finalValue =
                                                intValue < 0
                                                  ? "0"
                                                  : intValue.toString();

                                              handleOnChange(
                                                "paid_campaign_payment",
                                                {
                                                  ...campaignFormData?.paid_campaign_payment,
                                                  value: {
                                                    ...campaignFormData
                                                      ?.paid_campaign_payment
                                                      ?.value,
                                                    min: finalValue,
                                                  },
                                                }
                                              );
                                            }}
                                            onBlur={(e) => {
                                              const value = e.target.value;
                                              if (
                                                value &&
                                                value.includes(".")
                                              ) {
                                                const intValue = Math.floor(
                                                  parseFloat(value)
                                                );
                                                const finalValue =
                                                  intValue < 0
                                                    ? "0"
                                                    : intValue.toString();

                                                handleOnChange(
                                                  "paid_campaign_payment",
                                                  {
                                                    ...campaignFormData?.paid_campaign_payment,
                                                    value: {
                                                      ...campaignFormData
                                                        ?.paid_campaign_payment
                                                        ?.value,
                                                      min: finalValue,
                                                    },
                                                  }
                                                );
                                              }
                                            }}
                                          />
                                        </InputGroup>
                                      </Form.Group>

                                      <Form.Group
                                        controlId="formRangeMaxValue"
                                        className=""
                                      >
                                        <InputGroup>
                                          <InputGroup.Text>
                                            Max $
                                          </InputGroup.Text>
                                          <FormControl
                                            type="number"
                                            min="0"
                                            step="1"
                                            value={
                                              campaignFormData
                                                ?.paid_campaign_payment?.value
                                                ?.max || ""
                                            }
                                            onChange={(e) => {
                                              const value = e.target.value;
                                              if (value === "") {
                                                handleOnChange(
                                                  "paid_campaign_payment",
                                                  {
                                                    ...campaignFormData?.paid_campaign_payment,
                                                    value: {
                                                      ...campaignFormData
                                                        ?.paid_campaign_payment
                                                        ?.value,
                                                      max: "",
                                                    },
                                                  }
                                                );
                                                return;
                                              }
                                              const intValue = Math.floor(
                                                parseFloat(value)
                                              );
                                              const finalValue =
                                                intValue < 0
                                                  ? "0"
                                                  : intValue.toString();

                                              handleOnChange(
                                                "paid_campaign_payment",
                                                {
                                                  ...campaignFormData?.paid_campaign_payment,
                                                  value: {
                                                    ...campaignFormData
                                                      ?.paid_campaign_payment
                                                      ?.value,
                                                    max: finalValue,
                                                  },
                                                }
                                              );
                                            }}
                                            onBlur={(e) => {
                                              const value = e.target.value;
                                              if (
                                                value &&
                                                value.includes(".")
                                              ) {
                                                const intValue = Math.floor(
                                                  parseFloat(value)
                                                );
                                                const finalValue =
                                                  intValue < 0
                                                    ? "0"
                                                    : intValue.toString();

                                                handleOnChange(
                                                  "paid_campaign_payment",
                                                  {
                                                    ...campaignFormData?.paid_campaign_payment,
                                                    value: {
                                                      ...campaignFormData
                                                        ?.paid_campaign_payment
                                                        ?.value,
                                                      max: finalValue,
                                                    },
                                                  }
                                                );
                                              }
                                            }}
                                          />
                                        </InputGroup>

                                        {/* Validation messages */}
                                        {campaignFormData?.paid_campaign_payment
                                          ?.value?.min < 0 && (
                                          <Form.Text className="text-danger small d-block">
                                            Minimum payment cannot be negative
                                          </Form.Text>
                                        )}

                                        {campaignFormData?.paid_campaign_payment
                                          ?.value?.max < 0 && (
                                          <Form.Text className="text-danger small d-block">
                                            Maximum payment cannot be negative
                                          </Form.Text>
                                        )}

                                        {campaignFormData?.paid_campaign_payment
                                          ?.value?.min !== "" &&
                                          campaignFormData
                                            ?.paid_campaign_payment?.value
                                            ?.max !== "" &&
                                          parseInt(
                                            campaignFormData
                                              ?.paid_campaign_payment?.value
                                              ?.max
                                          ) <=
                                            parseInt(
                                              campaignFormData
                                                ?.paid_campaign_payment?.value
                                                ?.min
                                            ) && (
                                            <Form.Text className="text-danger small d-block">
                                              Maximum payment must be greater
                                              than minimum payment {}
                                              {
                                                campaignFormData
                                                  ?.paid_campaign_payment?.value
                                                  ?.min
                                              }
                                            </Form.Text>
                                          )}
                                      </Form.Group>
                                    </div>
                                  )}
                                </Form>
                              </div>
                            )}
                          </div>
                          {/* age restrictions box */}
                          <div className="age-box">
                            <div className="head">
                              <h6>Age Restrictions</h6>
                            </div>
                            <div key={"checkbox"} className="mb-3 mt-2">
                              <Form.Check
                                type={"Checkbox"}
                                label={"This product contains alcohol"}
                                checked={
                                  campaignFormData?.age_restriction?.includes(
                                    "Alcohol"
                                  ) || false
                                }
                                className=""
                                onClick={(e) => {
                                  const isChecked = e.target.checked;
                                  const updatedRestrictions = isChecked
                                    ? [
                                        ...(campaignFormData?.age_restriction ||
                                          []),
                                        "Alcohol",
                                      ]
                                    : campaignFormData?.age_restriction?.filter(
                                        (item) => item !== "Alcohol"
                                      );
                                  handleOnChange(
                                    "age_restriction",
                                    updatedRestrictions
                                  );
                                }}
                              />
                              <Form.Check
                                type={"Checkbox"}
                                label={"This product contains cannabis"}
                                className=""
                                checked={
                                  campaignFormData?.age_restriction?.includes(
                                    "Cannabis"
                                  ) || false
                                }
                                onClick={(e) => {
                                  const isChecked = e.target.checked;
                                  const updatedRestrictions = isChecked
                                    ? [
                                        ...(campaignFormData?.age_restriction ||
                                          []),
                                        "Cannabis",
                                      ]
                                    : campaignFormData?.age_restriction?.filter(
                                        (item) => item !== "Cannabis"
                                      );
                                  handleOnChange(
                                    "age_restriction",
                                    updatedRestrictions
                                  );
                                }}
                              />
                            </div>
                          </div>
                          {/* product description */}
                          <div className="product-desc-box">
                            <div className="head-detail">
                              <h6>Product Description</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              placeholder=""
                              style={{ height: "120px" }}
                              value={
                                campaignFormData?.product_description || ""
                              }
                              onChange={(e) =>
                                handleOnChange(
                                  "product_description",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          {/* campaign description */}
                          <div className="campagin-desc-box">
                            <div className="head-detail">
                              <h6>Campaign Description</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              style={{ height: "120px" }}
                              value={campaignFormData?.description || ""}
                              onChange={(e) =>
                                handleOnChange("description", e.target.value)
                              }
                            />
                          </div>
                          {/* whats to do */}
                          <div className="campagin-desc-box">
                            <div className="head-detail">
                              <h6>Campaign Description (What To Do)</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              style={{ height: "120px" }}
                              value={campaignFormData?.what_to || ""}
                              onChange={(e) =>
                                handleOnChange("what_to", e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();

                                  const textarea = e.target;
                                  const currentValue = textarea.value;
                                  const cursorPosition =
                                    textarea.selectionStart;
                                  const textBeforeCursor =
                                    currentValue.substring(0, cursorPosition);
                                  const textAfterCursor =
                                    currentValue.substring(cursorPosition);
                                  const newText =
                                    textBeforeCursor +
                                    "\n💥 " +
                                    textAfterCursor;
                                  textarea.value = newText;
                                  handleOnChange("what_to", newText);
                                  setTimeout(() => {
                                    const newCursorPosition =
                                      cursorPosition + 3;
                                    textarea.selectionStart = newCursorPosition;
                                    textarea.selectionEnd = newCursorPosition;
                                  }, 0);
                                }
                              }}
                              onFocus={(e) => {
                                if (!campaignFormData?.what_to?.trim()) {
                                  const textarea = e.target;
                                  textarea.value = "💥 ";
                                  handleOnChange("what_to", "💥 ");
                                }
                              }}
                            />
                          </div>
                          {/* whats not */}
                          <div className="campagin-desc-box">
                            <div className="head-detail">
                              <h6>Campaign Description (What Not Do)</h6>
                              <p>
                                In 1-2 sentences, describe what the creator will
                                receive from you.
                              </p>
                            </div>
                            <Form.Control
                              as="textarea"
                              style={{ height: "120px" }}
                              value={campaignFormData?.what_not_to || ""}
                              onChange={(e) =>
                                handleOnChange("what_not_to", e.target.value)
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();

                                  const textarea = e.target;
                                  const currentValue = textarea.value;
                                  const cursorPosition =
                                    textarea.selectionStart;
                                  const textBeforeCursor =
                                    currentValue.substring(0, cursorPosition);
                                  const textAfterCursor =
                                    currentValue.substring(cursorPosition);
                                  const newText =
                                    textBeforeCursor +
                                    "\n💥 " +
                                    textAfterCursor;
                                  textarea.value = newText;
                                  handleOnChange("what_not_to", newText);
                                  setTimeout(() => {
                                    const newCursorPosition =
                                      cursorPosition + 3;
                                    textarea.selectionStart = newCursorPosition;
                                    textarea.selectionEnd = newCursorPosition;
                                  }, 0);
                                }
                              }}
                              onFocus={(e) => {
                                if (!campaignFormData?.what_not_to?.trim()) {
                                  const textarea = e.target;
                                  textarea.value = "💥 ";
                                  handleOnChange("what_not_to", "💥 ");
                                }
                              }}
                            />
                          </div>
                          {/* hero image */}
                          <div className="hero-img-box">
                            <div className="head-detail">
                              <h6>Hero Images</h6>
                              <Uploader
                                listType="picture"
                                disabled={herofile ? true : false}
                                defaultFileList={
                                  campaignFormData.campaignLogo !== undefined
                                    ? [fileInfo]
                                    : []
                                }
                                multiple={false}
                                data={{ folder: "campaign" }}
                                method={"POST"}
                                className="mt-1  hero-image-upload "
                                accept="image/*"
                                action={ApiUrl.uploadLogo}
                                onRemove={(file) => {
                                  const updatedFormData = {
                                    ...campaignFormData,
                                    campaignLogo: {},
                                  };
                                  setCampaignFormData(updatedFormData);
                                  setHeroPreview(null);
                                }}
                                onSuccess={(response, file) => {
                                  handleHeroUpload({
                                    file: response?.file,
                                    key: file?.fileKey,
                                  });
                                }}
                                onUpload={(file) => {
                                  previewFile(file.blobFile, (value) => {
                                    setFileInfo(file);
                                  });
                                  const previewUrl = URL.createObjectURL(
                                    file.blobFile
                                  );
                                  setHeroPreview(previewUrl);
                                }}
                                onError={() => {
                                  setFileInfo(null);
                                  setHeroPreview(null);
                                }}
                              >
                                <button>
                                  <BsUpload />
                                  Upload Hero Image
                                </button>
                              </Uploader>
                            </div>
                          </div>
                          {/* gallery */}
                          <div className="gallery-img-box">
                            <div className="head-detail">
                              <h6>Gallery Images</h6>
                              <p>
                                We recommend uploading a minimum of 3 gallery
                                images or videos. For best results, make sure
                                the images are at a 1:1 (square) aspect ratio.
                              </p>
                              <Uploader
                                multiple
                                listType="picture"
                                accept="image/*"
                                defaultFileList={
                                  campaignFormData?.gallery !== undefined
                                    ? [fileInfo]
                                    : []
                                }
                                data={{ folder: "campaign/gallery" }}
                                method={"POST"}
                                className="gallery-img-upload"
                                action={ApiUrl.uploadLogo}
                                onSuccess={(response, file) => {
                                  setGalleryImages((prevImages) => [
                                    ...prevImages,
                                    {
                                      file: response?.file,
                                      key: file?.fileKey,
                                    },
                                  ]);
                                }}
                                onUpload={(file) => {
                                  previewFile(file.blobFile, (value) => {
                                    setFileInfo(file);
                                  });
                                }}
                                onError={() => {
                                  setFileInfo(null);
                                }}
                                onRemove={(file) => {
                                  const remaingImages = galleryImages?.filter(
                                    (item) => item.key != file?.keyfile
                                  );
                                  setGalleryImages(remaingImages);
                                }}
                              >
                                <button>
                                  <BsCloudUploadFill />
                                  <span> Upload files here</span>
                                  <span> Browse From Your Device</span>
                                </button>
                              </Uploader>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*requirnment-box  */}
                      <div ref={requirnment} className="requirnment-box box">
                        <h4 className="section-heading">Requirements</h4>
                        <p>
                          Set requirements for the type of creators you would
                          like to have for this campaign.
                        </p>
                        <div className="inner-content">
                          {/* age-box */}
                          <div className="age-range-box">
                            <h6>
                              Age range
                              <span> (optional, default is 13+)</span>
                            </h6>
                            <div className="mt-2 range-input">
                              <InputGroup>
                                <FormControl
                                  type="number"
                                  min="0"
                                  step="1"
                                  placeholder="Min"
                                  value={campaignFormData?.age?.min || ""}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "") {
                                      handleOnChange("age", {
                                        ...campaignFormData?.age,
                                        min: "",
                                      });
                                      return;
                                    }
                                    const numValue = parseInt(value);
                                    if (isNaN(numValue) || numValue < 0) {
                                      handleOnChange("age", {
                                        ...campaignFormData?.age,
                                        min: "",
                                      });
                                      return;
                                    }
                                    if (value.includes(".")) {
                                      const intValue = value.split(".")[0];
                                      handleOnChange("age", {
                                        ...campaignFormData?.age,
                                        min: intValue,
                                      });
                                      return;
                                    }

                                    handleOnChange("age", {
                                      ...campaignFormData?.age,
                                      min: value,
                                    });
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "." || e.key === ",") {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </InputGroup>
                              <InputGroup>
                                <FormControl
                                  type="number"
                                  min="0"
                                  step="1"
                                  placeholder="Max"
                                  value={campaignFormData?.age?.max || ""}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (value === "") {
                                      handleOnChange("age", {
                                        ...campaignFormData?.age,
                                        max: "",
                                      });
                                      return;
                                    }

                                    const numValue = parseInt(value);
                                    if (isNaN(numValue) || numValue < 0) {
                                      handleOnChange("age", {
                                        ...campaignFormData?.age,
                                        max: "",
                                      });
                                      return;
                                    }
                                    if (value.includes(".")) {
                                      const intValue = value.split(".")[0];
                                      handleOnChange("age", {
                                        ...campaignFormData?.age,
                                        max: intValue,
                                      });
                                      return;
                                    }

                                    handleOnChange("age", {
                                      ...campaignFormData?.age,
                                      max: value,
                                    });
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "." || e.key === ",") {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </InputGroup>
                            </div>

                            {/* Validation messages */}
                            {(campaignFormData?.age?.min < 0 ||
                              campaignFormData?.age?.max < 0) && (
                              <Form.Text className="text-danger small d-block mt-1">
                                Age cannot be negative
                              </Form.Text>
                            )}

                            {campaignFormData?.age?.min !== "" &&
                              campaignFormData?.age?.max !== "" &&
                              parseInt(campaignFormData?.age?.max) <=
                                parseInt(campaignFormData?.age?.min) && (
                                <Form.Text className="text-danger small d-block mt-1">
                                  Maximum age ({campaignFormData?.age?.max})
                                  must be greater than minimum age (
                                  {campaignFormData?.age?.min})
                                </Form.Text>
                              )}

                            {((campaignFormData?.age?.min &&
                              campaignFormData?.age?.min?.includes(".")) ||
                              (campaignFormData?.age?.max &&
                                campaignFormData?.age?.max?.includes("."))) && (
                              <Form.Text className="text-warning small d-block mt-1">
                                ⚠️ Decimal values are automatically converted to
                                whole numbers
                              </Form.Text>
                            )}
                          </div>
                          {/* gender-box */}
                          <div className="gender-box">
                            <div className="head">
                              <h6>
                                Genders
                                <span> (select all that apply)</span>
                              </h6>
                            </div>
                            <div key={"checkbox"}>
                              {campaignData?.genderTypes?.map((item, index) => (
                                <Form.Check
                                  key={`gender-${index}`}
                                  type={"Checkbox"}
                                  label={item.name}
                                  className=""
                                  checked={
                                    campaignFormData?.gender?.includes(
                                      item.name
                                    ) || false
                                  }
                                  onClick={(e) => {
                                    const isChecked = e.target.checked;
                                    const updatedGenders = isChecked
                                      ? [
                                          ...(campaignFormData?.gender || []),
                                          item.name,
                                        ]
                                      : campaignFormData?.gender?.filter(
                                          (item) => item !== item.name
                                        );

                                    handleOnChange("gender", updatedGenders);
                                  }}
                                />
                              ))}
                            </div>
                          </div>
                          {/*countries-box */}
                          <div className="countries-box">
                            <h6>Country</h6>
                            {/* {console.log("locations", campaignData?.loactions)} */}
                            <Select
                              options={campaignData?.loactions?.map((item) => ({
                                label: item.name,
                                value: item.id,
                                ...item,
                              }))}
                              placeholder={"Select"}
                              styles={customStyles}
                              isMulti
                              components={{
                                MultiValue: IconSingleValueCountry,
                                Option: CountryOption,
                              }}
                              onChange={(selectedOptions) =>
                                handleOnChange(
                                  "location_id",
                                  selectedOptions?.map((option) => option.id)
                                )
                              }
                            />
                          </div>
                          {/* niche-box*/}
                          <div className="niche-box">
                            <h6>
                              Niches <span>(areas of influence)</span>
                            </h6>
                            <Select
                              options={campaignData?.categories_list}
                              placeholder={"Niche"}
                              styles={customStyles}
                              isMulti
                              onChange={(selectedOptions) =>
                                handleOnChange(
                                  "category_id",
                                  selectedOptions?.map((option) => option.value)
                                )
                              }
                            />
                          </div>
                          {/* engagement-box */}
                          {campaignFormData?.campaign_strategy !== 1 &&
                            campaignFormData?.campaign_platform?.map(
                              (item, index) => (
                                <div
                                  className="engagement-box"
                                  key={`social-platform-${index}`}
                                >
                                  <h6>
                                    <img
                                      src={getSocialPlatform(item.id)?.icon}
                                      alt="Platform Icon"
                                    />
                                    {item?.name}
                                  </h6>
                                  <div className="mt-2 follower-range-input">
                                    <Form.Group controlId="formRangeMinValue">
                                      <Form.Label>Followers</Form.Label>
                                      <FormControl
                                        type="number"
                                        label="Followers"
                                        value={
                                          item?.social_engagement_data
                                            ?.follower || ""
                                        }
                                        onChange={(e) => {
                                          const campaign_platforms = [
                                            ...campaignFormData?.campaign_platform,
                                          ];
                                          campaign_platforms[
                                            index
                                          ].social_engagement_data.follower =
                                            e.target.value;
                                          handleOnChange(
                                            "campaign_platform",
                                            campaign_platforms
                                          );
                                        }}
                                      />
                                    </Form.Group>
                                    <Form.Group controlId="formRangeMaxValue">
                                      <Form.Label>Engagement</Form.Label>
                                      <FormControl
                                        type="number"
                                        label="Engagement"
                                        value={
                                          item?.social_engagement_data
                                            ?.engagement || ""
                                        }
                                        onKeyPress={(e) => {
                                          if (
                                            e.target.value.length >= 2 &&
                                            e.key !== "Backspace" &&
                                            e.key !== "Delete"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onChange={(e) => {
                                          const campaign_platforms = [
                                            ...campaignFormData?.campaign_platform,
                                          ];
                                          campaign_platforms[
                                            index
                                          ].social_engagement_data.engagement =
                                            e.target.value;
                                          handleOnChange(
                                            "campaign_platform",
                                            campaign_platforms
                                          );
                                        }}
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                      {/*deliverables-box  */}
                      <div ref={deliverables} className="deliverables-box box">
                        <h4 className="section-heading">Deliverables</h4>
                        <p>
                          Provide guidance on the type and quality of content
                          you would like from creators for this campaign.
                        </p>
                        <div className="inner-content">
                          {/* content-format */}
                          {campaignFormData?.campaign_strategy !== 1 && (
                            <div className="content-formats-box">
                              <h6>Content-Formats</h6>
                              <p>
                                Provide a visual description or theme for how
                                the creator's content should look and feel.
                              </p>
                              <div className=" mt-3 content-range-input">
                                <FormControl
                                  type="number"
                                  min="0"
                                  value={contentFormatCounts?.video}
                                  onChange={(e) =>
                                    setContentFormatCounts({
                                      ...contentFormatCounts,
                                      video: e.target.value,
                                    })
                                  }
                                />
                                <div className="img-section">
                                  {getSocialPlatformbyName("instagram") && (
                                    <img
                                      src={Images.instagram}
                                      alt="instagram"
                                    />
                                  )}
                                  {getSocialPlatformbyName("youtube") && (
                                    <img src={Images.youtube} alt="youtube" />
                                  )}
                                  {getSocialPlatformbyName("tiktok") && (
                                    <img src={Images.tikTok} alt="tik-tok" />
                                  )}
                                  <span>Video</span>
                                </div>
                              </div>
                              {/* shorts */}
                              {getSocialPlatformbyName("youtube") && (
                                <div className=" mt-3 content-range-input">
                                  <FormControl
                                    type="number"
                                    min="0"
                                    value={contentFormatCounts?.shorts}
                                    onChange={(e) =>
                                      setContentFormatCounts({
                                        ...contentFormatCounts,
                                        shorts: e.target.value,
                                      })
                                    }
                                  />
                                  <div className="img-section">
                                    <img src={Images.youtube} alt="youtube" />
                                    <span>Shorts</span>
                                  </div>
                                </div>
                              )}
                              {getSocialPlatformbyName("Instagram") && (
                                <>
                                  {/* story */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.story}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          story: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>Story</span>
                                    </div>
                                  </div>
                                  {/* IGTV */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.igtv}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          igtv: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>IGTV</span>
                                    </div>
                                  </div>
                                  {/* reel */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.reel}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          reel: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>Reel</span>
                                    </div>
                                  </div>
                                  {/* post */}
                                  <div className=" mt-3 content-range-input">
                                    <FormControl
                                      type="number"
                                      min="0"
                                      value={contentFormatCounts?.post}
                                      onChange={(e) =>
                                        setContentFormatCounts({
                                          ...contentFormatCounts,
                                          post: e.target.value,
                                        })
                                      }
                                    />
                                    <div className="img-section">
                                      <img
                                        src={Images.instagram}
                                        alt="instagram"
                                      />
                                      <span>Post</span>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                          {/* inspiration-box */}
                          <div className="inspiration-box">
                            <h6>Inspiration Board</h6>
                            <p>
                              Include images or videos you would like to use to
                              inspire your creator's artistic direction. For
                              best results, make sure the images are at a 1:1
                              (square) aspect ratio.
                            </p>
                            <Uploader
                              multiple
                              listType="picture"
                              accept="video/*,image/*"
                              action={ApiUrl.uploadLogo}
                              data={{ folder: "campaign/inspiration" }}
                              className="insprition-img-upload"
                              method={"POST"}
                              defaultFileList={
                                campaignFormData?.inspiration_board !==
                                undefined
                                  ? [fileInfo]
                                  : []
                              }
                              onSuccess={(response, file) => {
                                setInspritionImages((prevImages) => [
                                  ...prevImages,
                                  {
                                    file: response?.file,
                                    key: file?.fileKey,
                                  },
                                ]);
                              }}
                              onUpload={(file) => {
                                previewFile(file.blobFile, (value) => {
                                  setFileInfo(file);
                                });
                              }}
                              onRemove={(file) => {
                                const remaingImages = inspritionImages?.filter(
                                  (item) => item.key != file?.keyfile
                                );
                                setInspritionImages(remaingImages);
                              }}
                              onError={() => {
                                setFileInfo(null);
                              }}
                            >
                              <button>
                                <BsCloudUploadFill />
                                <span> Drag files here</span>
                                <span> or Browse From Your Device</span>
                              </button>
                            </Uploader>
                          </div>
                          {/* visuals-box */}
                          <div className="visuals-box">
                            <h6>Visuals & Theme</h6>
                            <p>
                              Provide a visual description or theme for how the
                              creator's content should look and feel.
                            </p>
                            <Form.Control
                              as="textarea"
                              placeholder=""
                              style={{ height: "120px" }}
                              value={campaignFormData?.visuals_theme || ""}
                              onChange={(e) =>
                                handleOnChange("visuals_theme", e.target.value)
                              }
                            />
                          </div>
                          {/* captions-box */}
                          <div className="captions-box">
                            <h6>Captions or Hastags</h6>
                            <p>
                              Provide some guidance for what the creator's
                              caption should say. Remember the caption is an
                              important part of their identity. The more freedom
                              you allow, the more authentic the post will appear
                              to their followers.
                            </p>
                            <p>
                              <strong>
                                *TikTok captions have a character limit of 100,
                                including hashtags & spaces.
                              </strong>
                            </p>
                            <Form.Control
                              as="textarea"
                              placeholder=""
                              style={{ height: "120px" }}
                              value={campaignFormData?.caption || ""}
                              onKeyDown={(e) => {
                                const textarea = e.target;
                                const cursorPosition = textarea.selectionStart;
                                const currentValue = textarea.value;
                                if (
                                  e.key.length > 1 ||
                                  e.ctrlKey ||
                                  e.metaKey ||
                                  e.key === " " ||
                                  e.key === "@" ||
                                  e.key === "#"
                                ) {
                                  return;
                                }
                                let wordStart = cursorPosition;
                                while (
                                  wordStart > 0 &&
                                  currentValue[wordStart - 1] !== " "
                                ) {
                                  wordStart--;
                                }
                                const firstChar = currentValue[wordStart];
                                if (firstChar !== "@" && firstChar !== "#") {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) =>
                                handleOnChange("caption", e.target.value)
                              }
                            />
                          </div>
                          {/* hashtag-box */}
                          {/* <div className="hashtag-box">
                            <h6>Content Capture Tags</h6>
                            <p>
                              We use hashtags and mentions to capture content
                              created for your campaigns, so be sure these are
                              unique to each campaign.
                            </p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="campagin-view-wrapper">
                    <div className="submit-btn">
                      <Button onClick={() => handleSubmit()}>
                        <BsUpload />
                        Submit For Review
                      </Button>
                    </div>
                    <div className="campagin-view-inner">
                      <div className="tab-list">
                        <ul>
                          <li
                            className={activeMenu === general ? "active" : ""}
                            onClick={() => scrollToSection(general)}
                          >
                            General
                          </li>
                          <li
                            className={
                              activeMenu === compensation ? "active" : ""
                            }
                            onClick={() => scrollToSection(compensation)}
                          >
                            Compensation
                          </li>
                          <li
                            className={
                              activeMenu === requirnment ? "active" : ""
                            }
                            onClick={() => scrollToSection(requirnment)}
                          >
                            Requirements
                          </li>
                          <li
                            className={
                              activeMenu === deliverables ? "active" : ""
                            }
                            onClick={() => scrollToSection(deliverables)}
                          >
                            Deliverables
                          </li>
                        </ul>
                      </div>
                      {/* product draft */}
                      <div className="draft-card-wrapper">
                        <div className="draft-card">
                          <h6 className="company">
                            {auth?.user?.company_name}
                          </h6>
                          <h6>
                            {campaignFormData?.campaign_title ||
                              "Campaign Title"}
                          </h6>
                          <div className="img-box">
                            {heroPreview && (
                              <img
                                src={heroPreview}
                                alt="Hero preview"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                            )}
                          </div>
                          <div className="content-box">
                            <div className="followers common-box">
                              <span>followers</span>
                              <span className="data">
                                {getFollowersRange(
                                  campaignFormData?.campaign_platform
                                ) || "-"}
                              </span>
                            </div>
                            <div className="Engagement common-box">
                              <span>Engagement</span>
                              <span className="data">
                                {getEngagementRange(
                                  campaignFormData?.campaign_platform
                                ) || "-"}
                              </span>
                            </div>
                            <div className="Age common-box">
                              <span>Age</span>
                              <span className="data">{getAgeRange()}</span>
                            </div>
                            <div className="Residence common-box">
                              <span>Residence</span>
                              <span className="data">{getCountryCodes()}</span>
                            </div>
                            <p className="diabled-btn">{getSelectedNiches()}</p>
                            {/* <div className="strategy-channel">
                              <img src={Images.speaker} alt="strategy" />
                              <img src={Images.instagram} alt="channel" />
                            </div> */}
                          </div>
                          <p className="tag">Draft Campaign</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
};
export default CreateCampagin;
